import ManagerFlightSetting from './ManagerFlightSetting';

export default ManagerFlightSetting;
